'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _BadgeConstants = require('./BadgeConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BADGE_CLASSES = {
  beta: 'private-badge--beta',
  count: 'private-badge--notification private-badge--count',
  dot: 'private-badge--notification private-badge--dot',
  free: 'private-badge--free',
  new: 'private-badge--new',
  none: ''
};

var BADGE_USES = _extends({}, BADGE_CLASSES, _BadgeConstants.BADGE_COLORS);

var UIBadge = _react2.default.createClass({
  displayName: 'UIBadge',

  propTypes: {
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    use: _react.PropTypes.oneOf(Object.keys(BADGE_USES))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      use: 'free'
    };
  },
  getClassName: function getClassName(className, use) {
    return (0, _reactUtils.classNames)(BADGE_USES[use], className, {
      'private-badge': !(use === 'count' || use === 'dot')
    });
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'use']);

    return _react2.default.createElement(
      'span',
      _extends({}, rest, { className: this.getClassName(className, use) }),
      children
    );
  }
});

exports.default = UIBadge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/badge/UIBadge.js
// module id = 313
// module chunks = 0